import { useCallback, useEffect } from 'react';
import useTask from '../../../../modules/tasks/hooks/use-task';
import LibraryEmail from '../../../library-email';
import QuestionBox from '../../../question-box';
import './style.scss';

type Props = {
    onComplete?: () => void
}

const Task402: React.FC<Props> = ({ onComplete: completeCallback }) => {

    const onComplete = useCallback(() => {
        if (completeCallback) {
            completeCallback();
        }
    }, [completeCallback]);

    const { task } = useTask('t-402');

    useEffect(() => {
        onComplete();
    }, [onComplete])

    return <div className="task task-402">
        <h2>zadanie 2</h2>
        <h3>{task?.title}</h3>
        <p>
            Stanisław Lem jest najbardziej znanym polskim pisarzem gatunku hard science fiction. Gatunek ten kładzie bardzo duży nacisk na opisywanie nieistniejącej (jeszcze) nauki i technologii. Co ciekawe, wiele przedmiotów opisywanych przez Lema jest dziś używanych! To właśnie on jako pierwszy opisał czytnik e-booków czy tablety. Co powiecie na spróbowanie swoich sił w tym gatunku? Stwórzcie autorską bajkę, w której kluczową rolę będą odgrywały postaci stworzone przez Lema! Może tym razem Czerwony Kapturek spotyka elektrowilka roombę albo 3 świnki schowają się w bunkrze przeciwatomowym?
        </p>
        <p className="instruction">
            <strong>Zadanie:</strong> Wybierzcie trzech bohaterów lub trzy przedmioty z poniższej listy i stwórzcie krótką bajkę w której będą one odgrywały kluczową rolę!
        </p>

        <div className='task-cards'>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Stara Maszyna Cyfrowa</h3>
                    <p>stara, mądra maszyna cyfrowa, od lat nieużywana, pomogła królowi zniszczyć smoka za pomocą zagadek</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Klapaucjusz</h3>
                    <p>robot konstruktor, który pracował nad Maszyną do Spełniania Życzeń</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Automateusz</h3>
                    <p>robot, który postanawia zakupić sobie elektrycznego, mikroskopijnego przyjaciela</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Szafa Wróżąca</h3>
                    <p>maszyna, która po pokręceniu korbką wyrzuca kartkę z wróżbą</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Trurl</h3>
                    <p>przyjaciel Klapaucjusza, też robot konstruktor; zwany był także Konstruktorem Najgorszych Maszyn na Świecie</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Maszyna do Spełniania Życzeń</h3>
                    <p>maszyna, która spełnia życzenia konstruktorów</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Baryon Lodousty</h3>
                    <p>mędrzec, który pomógł pokonać Elektrycerzy</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Smok</h3>
                    <p>mieszkał na Księżycu, stworzony przez maszynę wojenną w drodze pomyłki</p>
                </div>
            </label>
            <label>
                <input type="checkbox" />
                <div className='card'>
                    <h3>Maszyna</h3>
                    <p>dziwaczne urządzenie wynalezione przez Trurla. Umiała robić wszystko, co zaczynało się na literę „n”</p>
                </div>
            </label>
        </div>
        <QuestionBox>
            <p>
                Co byłoby gdyby pisarze nie publikowali swojej twórczości? Pochwalcie się Waszymi bajkami, przesyłając je na adres e-maliowy Waszej biblioteki!
            </p>
        </QuestionBox>
        <LibraryEmail />
    </div>
}

export default Task402;
